import { defaultRegStr, defaultEmoji } from './config';

export function getDom(el) {
    if (typeof el === 'string') {
        if (!document.getElementById(el)) {
            console.error(`can not get dom of #${el}`);
            return;
        }
        return document.getElementById(el);
    }
    return el;
}

export function stopPropagation(e) {
    e = e || window.event;
    if (e.stopPropagation) {
        //W3C阻止冒泡方法
        e.stopPropagation();
    } else {
        e.cancelBubble = true; //IE阻止冒泡方法
    }
}

export function hasEmoji(emojis, r) {
    return emojis.find(i => i.code === r);
}

export function transCode2Img(msg) {
    const { emojis, regStr, options } = this;

    if (!msg) {
        return '';
    }
    msg = msg.replace(/[\n]/gi, '<br/>');
    var reg = new RegExp(regStr, 'g');
    msg = msg.replace(reg, function(r) {
        const emojiObj = hasEmoji(emojis, r);
        if (emojiObj) {
            return `<img draggable="false" class="${options.mode === 'mobile' ? 'rhemoji-emo-mobile' : 'rhemoji-emo'}" src="${emojiObj.src}" data-type="${emojiObj.code}">`;
        } else {
            return msg;
        }
    });
    return msg;
}

export function setDeleteIconSrc(newContent, deleteIcon) {
    if (newContent.length === 0) {
        deleteIcon.src = 'https://upload.9fzt.com/production/frontend/archive/rhemoji/images/mobile-emoji-delete-disabled.png';
    } else {
        deleteIcon.src = 'https://upload.9fzt.com/production/frontend/archive/rhemoji/images/mobile-emoji-delete.png';
    }
}

export function mobile_deleteIconClick() {
    stopPropagation();
    let content = this.getContent();
    const { regStr, deleteIcon } = this;
    // 如果是空的内容直接跳出
    if (content === '') return;
    const reg = new RegExp(regStr, 'g');
    const result = content.match(reg);

    let newContent = '';
    if (!result || result.length === 0) {
        // 没有表情
        content = content.substring(0, content.length - 1);
        newContent = this.transCode2Img(content);
    } else {
        // 表情最后一个的位置
        const lastIndex = content.lastIndexOf(result[result.length - 1]);
        if (content.length === lastIndex + result[result.length - 1].length) {
            // 最后一个是表情
            content = content.substring(0, content.length - result[result.length - 1].length);
            newContent = this.transCode2Img(content);
        } else {
            content = content.substring(0, content.length - 1);
            newContent = this.transCode2Img(content);
        }
    }
    setDeleteIconSrc(newContent, deleteIcon);
    this.onContentChange(content);
    this.input_el.innerHTML = newContent;
}

export function resetRange() {
    const selection = window.getSelection();
    this.lastEditRange = selection.getRangeAt(0);
}

export function transCode2ImgFn(msg, mode = 'pc') {
    if (!msg) {
        return '';
    }
    msg = msg.replace(/[\n]/gi, '<br/>');
    var reg = new RegExp(defaultRegStr, 'g');
    msg = msg.replace(reg, function(r) {
        const emojiObj = hasEmoji(defaultEmoji, r);
        if (emojiObj) {
            return `<img draggable="false" class="${mode === 'mobile' ? 'rhemoji-emo-mobile' : 'rhemoji-emo'}"src="${emojiObj.src}" data-type="${emojiObj.code}">`;
        } else {
            return msg;
        }
    });
    return msg;
}
